import { injectIntl } from 'react-intl';

import useDropdownData from '../../../Shared/hooks/useDropdownData';
import useHelpData from '../../../Shared/hooks/useHelpData';
import HelpMenuOption from '../../../Shared/components/HelpMenuOption';
import HelpDropdown from '../../../Shared/components/HelpDropdown';
import { HELP_MENU_OPTIONS } from './config';
import { IntlType } from '../../type';
import { Suspense, useEffect, useState } from 'react';
import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';

import { DYNAMIC_REMOTES } from '~/config/app.constants';
import { useUserAuth } from '~/components/Auth';
import useTracker from '../../hooks/useTracker';
import { PRIVACY_POLICY_URL } from '../../config/constants';
import useSupportActions from '~/hooks/useSupportActions';
import useEchoWidget from '~/components/Echo/hooks/useEchoWidget';

type HelpProps = {
  intl: IntlType;
};

const Help = ({ intl }: HelpProps) => {
  const {
    berryActions,
    navigate,
    isEchoEnabled,
    isBerryChatDisabledForLearner,
    isGetSupportInitialized,
  } = useHelpData();
  const { isVisible, onHideDropdownContent, handleVisibilityChange } = useDropdownData();
  const track = useTracker();
  const { isEchoWidgetLoaded, toggleEchoWidget } = useEchoWidget();

  const {
    company,
    email,
    locale = 'en',
    tempFeatureConfig: { customPrivacyPolicyLink = {}, hideHelpSiteLink = false } = {},
  } = useUserAuth();

  const [addGetSupport, setAddGetSupport] = useState(false);

  const privacyPolicyLink = customPrivacyPolicyLink[locale] || PRIVACY_POLICY_URL;

  useEffect(() => {
    if (isVisible && !addGetSupport) {
      setAddGetSupport(true);
    }
  }, [isVisible, addGetSupport]);

  const { openGetSupport } = useSupportActions({
    navigate,
    berryActions,
    isBerryChatDisabled: isBerryChatDisabledForLearner,
  });

  const actionConfig = {
    company,
    onHideDropdownContent,
    isGetSupportInitialized,
    isEchoEnabled,
    isBerryChatDisabledForLearner,
    privacyPolicyLink,
    hideHelpSiteLink,
    track,
    intl,
    openGetSupport,
    isEchoWidgetLoaded,
    toggleEchoWidget,
  };

  return (
    <div>
      <HelpDropdown
        options={<HelpMenuOption helpMenuOptions={HELP_MENU_OPTIONS(actionConfig)} />}
        isVisible={isVisible}
        handleVisibilityChange={handleVisibilityChange}
      />
      {addGetSupport && (
        <Suspense fallback={<span />}>
          <LoadRemote remote={DYNAMIC_REMOTES.GET_SUPPORT} loader={<span />} email={email} />
        </Suspense>
      )}
    </div>
  );
};

export default injectIntl(Help);
